
import packageJson from "../../../package.json";
import { ReactComponent as SearchPerson } from "../../assets/person_search_black_24dp.svg";
import { ReactComponent as RemoveShoppingCart } from "../../assets/remove_shopping_cart_black_24dp.svg";
import { Link } from "react-router-dom";
import { TITLE } from "../../core/consts";
import logo from "../../assets/logo.png";
import IconButton from "@mui/material/IconButton";
import { ArrowLeft, ExitToApp, ListAlt, PieChart, GolfCourse, Assessment } from "@mui/icons-material";
import { useEffect, useState, ElementType } from "react";
import { post, get } from '../../core/client';
import { CircularProgress } from "@mui/material";

interface SideBarProps {
  isOpen: boolean;
  onClose: () => void;
}

interface MenuItem {
  name: string;
  symbol: ElementType;
  url: string;
}

interface MenuResponse {
  transactionIds: Array<number>;
}


const SideBar: React.FC<SideBarProps> = props => {

  const [state, setState] = useState<Array<MenuItem>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [defaultMenuVisible, setDefaultMenuVisible] = useState<boolean>(true);

  useEffect(() => {
    loadMenu();
  }, []);

  const loadMenu = async () => {
    setLoading(true);
    var response = await get<MenuResponse>("api/user/menu", "");
    const menus = prepareMenuItems(response);
    setState(menus);
    setLoading(false);
  };

  const prepareMenuItems = (items: MenuResponse) => {
    const menus: MenuItem[] = [];
    if (items.transactionIds.includes(1124)) {
      setDefaultMenuVisible(false);
      menus.push({name: "MVK Rezervasyon Sorgulama", symbol: GolfCourse, url: "/mvk-reservation-info"})
      menus.push({name: "MVK Rezervasyon Raporlama", symbol: Assessment, url: "/report-mvk-reservation"})
    }
    return menus;
  }

  const drawMenu = (items: Array<MenuItem>) => {""
    return (
      <div>
        {items.map((menu) => (
          <div className="sidebar-item">
          <Link className="link" to={menu.url}>
            <menu.symbol className="icon" />
            <span>{menu.name}</span>
          </Link>
          </div>
        ))}
        </div>
    );
  };

  return (
    <div className={`sidebar ${props.isOpen ? "sidebar-open" : ""}`}>
      <div className="sidebar-wrapper">
        <div className="aside-top">
          <div className="top-gap">
            <IconButton className="close-menu-button" onClick={() => props.onClose()}>
              <ArrowLeft />
            </IconButton>
          </div>
          <div className="brand">
            <a href="/" className="logo">
              <img src={logo} title={TITLE} alt={TITLE} />
            </a>
            <p>{TITLE}</p>
          </div>
        </div>
        <div className="aside-content">
          {!loading && defaultMenuVisible && (
            <div>
              <div className="sidebar-item">
                <Link className="link" to="/uye-sorgula">
                  <SearchPerson className="icon" />
                  <span>ÜYE SORGULA</span>
                </Link>
              </div>
              <div className="sidebar-item">
                <Link className="link" to="/alisveris-iptal">
                  <RemoveShoppingCart className="icon" />
                  <span>ALIŞVERİŞ İPTAL</span>
                </Link>
              </div>
              <div className="sidebar-item">
                <Link className="link" to="/raporlama">
                  <PieChart className="icon" />
                  <span>RAPORLAMA</span>
                </Link>
              </div>
              <div className="sidebar-item">
                <Link className="link" target={"_blank"} to="/docs/kullanim_kilavuzu_V2.pdf">
                  <ListAlt className="icon" />
                  <span>KULLANIM KILAVUZU</span>
                </Link>
              </div>
            </div>
          )}
          { loading ? (
            <CircularProgress size={20} thickness={5} />
          ) : state.length > 0 && drawMenu(state)
          }
          <div className="sidebar-item">
            <Link className="link" to="/logout">
              <ExitToApp className="icon" />
              <span>ÇIKIŞ</span>
            </Link>
          </div>
        </div>
        <div className="version">Version {packageJson.version}</div>
      </div>
    </div>
  );
};

export default SideBar;
